import { render, staticRenderFns } from "./TrainingSelectedVideo.vue?vue&type=template&id=0c073836&scoped=true&"
import script from "./TrainingSelectedVideo.vue?vue&type=script&lang=js&"
export * from "./TrainingSelectedVideo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSelectedVideo.vue?vue&type=style&index=0&id=0c073836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c073836",
  null
  
)

export default component.exports